import React, { useCallback, useContext, useState } from "react";
import embLabels from "../../config/emb-labels-en.json";
import batteryImage from "../../images/BESS-image-SE.png";
import ACTIONS from "./Design_Asset_Actions.json";

import { AssetBlockContext } from "../CustomHooks/ContextApi";
import isTouchDevice from "../SE-Component/Tooltip";
import Tooltip from "../../utils/Tooltip";
import { getProjectTypeValue } from "../../utils/project";
import useProjectTypeValue from "../../utils/useCurrentProjectValue";
import Alert from "../SE-Component/Alert";
import { useAtom } from "jotai";
import { projectAtomList } from "../../atoms";
const BatteryAsset = () => {
  const [toolTipData, setToolTiData] = useAtom(projectAtomList);
   const [alert, setAlert] = useState({
      message: "",
      alertPopUpStatus: false,
      title: "",
    });
  const {
    CBAssetList,
    CBAssetListDispatch,
    architectureType,
    assetDetailsDisplay,
    setAssetSelection,
    configData,
    handleBatteryChange,
    defaultsMinMax,
    updateBatteryConfig,
    checkBatteryRemoveCondition,
    gsxExternalId,
    siteType,
    selectedValues,
    clientType,
    defaultCbData,
    handleCbAssetRequired,
    handleEnergyReserve,
    handlePmAssetRequired,
    spanishCodeRealTime,
    handleBessController,
    gridSettingMode,
  } = useContext(AssetBlockContext);

  if (!configData?.configData) {
    return null;
  }

  if (!Array.isArray(CBAssetList)) {
    return null;
  }

  const maxPowerBessMax = configData?.configData?.quantityOfBess
    ? configData?.configData?.quantityOfBess * defaultsMinMax?.maxPowerBessMax
    : defaultsMinMax?.maxPowerBessMax;
  const capacityBessMax = configData?.configData?.quantityOfBess
    ? configData?.configData?.quantityOfBess * defaultsMinMax?.capacityBessMax
    : defaultsMinMax?.capacityBessMax;
  const setAssetHandler = () => setAssetSelection(embLabels.BESS);
  const projectTypeValue = useProjectTypeValue();
  const batteryChangeHandler = (e) => {
    handleBatteryChange(e);
  };
  let values = CBAssetList[2]?.assetDetails[0]?.assetAttributes?.filter(
    (item) => item?.type === "max_power"
  )[0]?.value;
  values = typeof values === "string" ? JSON.parse(values) : "";

  const {
    soc_min = "",
    soc_max = "",
    soc_nominal_power = "",
  } = configData?.configData;

  const validateSocNominalPower = () => {
    if (
      (siteType === embLabels.ISLANDABLE ||
        siteType === embLabels.ISLANDABLE_GSX) &&
      parseInt(soc_nominal_power) >
        parseInt(defaultsMinMax?.socEmergencyDefault) &&
      parseInt(soc_nominal_power) >
        parseInt(defaultsMinMax?.socEssentialDefault) &&
      parseInt(soc_nominal_power) < parseInt(soc_max)
    ) {
      return true;
    } else if (
      (siteType === embLabels.GRID_CONNECTED ||
        siteType === embLabels.GRID_CONNECTED_GSX) &&
      parseInt(soc_nominal_power) > parseInt(soc_min) &&
      parseInt(soc_nominal_power) < parseInt(soc_max)
    ) {
      return true;
    } else {
      return false;
    }
  };

  const isValid = validateSocNominalPower();
  let isBessController =
    CBAssetList[2]?.assetDetails[0]?.assetAttributes?.filter(
      (item) => item?.type === "isMultiBess"
    )[0]?.value;
  isBessController =
    typeof isBessController === "string" ? JSON.parse(isBessController) : false;
  let isBoostPro = CBAssetList[2]?.assetDetails[0]?.assetAttributes?.filter(
    (item) => item?.type === "isBoostPro"
  )[0]?.value;
  isBoostPro =
    typeof isBoostPro === "string" ? JSON.parse(isBoostPro) : false;

    let isacCoulpedPcu = CBAssetList[2]?.assetDetails[0]?.assetAttributes?.filter(
    (item) => item?.type === "isacCoulpedPcu"
  )[0]?.value;
  isacCoulpedPcu =
    typeof isacCoulpedPcu === "string" ? JSON.parse(isacCoulpedPcu) : false;
  // Derive selected asset references safely
  const selectedIndex = selectedValues?.selectedAsset;
  const selectedAsset = CBAssetList?.[selectedIndex];
  const bessControllerEnabled = !!selectedAsset?.uiData?.bessController;
  // Unified visibility condition for BESS paralleling checkbox (deduped blocks)
  const canShowBessParalleling =
    isBessController &&
    (clientType === embLabels.GENERIC_PROJECT || clientType === embLabels.GREENSTRUXURE_PROJECT) &&
    (
      // Case 1: Islandable GSX + DaaS ANSI
      ([embLabels.ISLANDABLE_GSX].includes(siteType) && ["DaaS ANSI"].includes(projectTypeValue)) ||
      // Case 2: Other supported site types + listed project types
      ([
        embLabels.GRID_CONNECTED,
        embLabels.GRID_CONNECTED_GSX,
        embLabels.ISLANDABLE,
        embLabels.ISLANDABLE_GSX, // include GSX here so second condition also shows it
      ].includes(siteType) && ["DaaS ANSI", "DaaS ETO", "MGaaS ANSI"].includes(projectTypeValue))
    );
  const handleEnergyRquired = (e) => {
    const { name, checked } = e.target;
    handleEnergyReserve(selectedValues.selectedAsset, checked);
  };
  const closeAlertMessage = useCallback(() => {
      setAlert({
        message: "",
        alertPopUpStatus: false,
        title: "",
      });
      updateBatteryConfig(selectedValues?.selectedAsset)
    }, [alert]);
const AlertMessages = {
  boostProAlert: () => (
    <>
    <b>{"Services managed by eStar:"}</b> <br />
    <span>{"eStar is a Joint Venture of Schneider Electric whose name is visible on the product.  The support and services on this product shall be addressed to"}</span> <b>eStar</b> {"directly."}
    </>
  ),
};
  return (
    <div name="battery" className="col-md-12 p-0">
      <div className="col-md-12 pt-2 pl-4 se-white-background">
        <div className="row">
          <div className="col-md-8 pb-2 pl-0 ">
            <div className="d-flex">
              <se-icon
                color="primary"
                className="se-icon icon_button se-life-green"
                size="medium"
              >
                battery2_half
              </se-icon>
              <div className="ml-2 bold align-top">
                Battery Energy Storage System
              </div>
            </div>
          </div>
          {architectureType === embLabels.PV_BESS_NR ||
          siteType === "ISLANDABLE_GSX" ? null : (
            <div className="col-md-4">
              <span className="float-right">
                <button
                  disabled={
                    projectTypeValue === "MGaaS ANSI" &&
                    siteType === "ISLANDABLE"
                      ? false
                      : true
                  }
                  type="button"
                  className="btn btn-secondary btn-sm"
                  onClick={
                    projectTypeValue === "MGaaS ANSI" &&
                    siteType === "ISLANDABLE"
                      ? undefined
                      : checkBatteryRemoveCondition
                  }
                >
                  Remove
                </button>
              </span>
            </div>
          )}
        </div>
      </div>

      <div className="col-md-12 col-sm-12 pt-2 pb-2 se-grey-background se-border">
        <div
          className="row"
          style={assetDetailsDisplay.manufacturer ? {} : { display: "none" }}
        >
          <div className="col-md-3">
            {assetDetailsDisplay.imageLink === null ? (
              assetDetailsDisplay.manufacturer === "SCHNEIDER ELECTRIC" ? (
                <img
                  src={batteryImage}
                  className="asset-image-display"
                  alt={assetDetailsDisplay.manufacturer}
                />
              ) : (
                <se-icon color="primary" size="large">
                  battery2_half
                </se-icon>
              )
            ) : (
              <img
                src={assetDetailsDisplay.imageLink}
                className="asset-image-display"
                alt={assetDetailsDisplay.manufacturer}
              />
            )}
          </div>

          <div className="col-md-9">
            <div className="row">
              <div className="col-md-10 bold ml-2">
                {assetDetailsDisplay.manufacturer}
              </div>
            </div>
            <div className="row">
              <div className="col-md-8 ml-2 text-break">
                {assetDetailsDisplay.communicationModel}
              <div className="bold">AC-Coupled System</div>
              </div>
              <div className="col-md-2">
               {  isBoostPro? 
             <Tooltip
                  position="left"
                  iconColor="secondary"
                  information={`${toolTipData?.tooltipData?.eStarBoostPro?.data}`}  />
            :<Tooltip
                  position="left"
                  iconColor="secondary"
                  information="AC Coupled Power Conversion unit, to be coupled with battery system from qualified battery vendor."
                />}
              </div>
            </div>
          </div>
        </div>

        <div
          className="row"
          style={assetDetailsDisplay.manufacturer ? { display: "none" } : {}}
        >
          <div className="ml-2 mb-2 asset-selection"> No assets selected</div>
        </div>
        <div
          className="row"
          // style={
          //   architectureType === embLabels.PV_BESS_NR ? { display: "none" } : {}
          // }
        >
          <div className=" col-md col-sm col-lg text-center">
            <se-button option="outline" size="small" onClick={setAssetHandler}>
              Asset Selection
            </se-button>
          </div>
        </div>
      </div>

      <div style={assetDetailsDisplay.manufacturer ? {} : { display: "none" }}>
        <div className="col-md-12 pt-1 pb-1 se-white-background align-middle se-border">
          <div className="row">
            <label className="col-md-5 bold mt-2 mb-2  se-font-14px">
              Asset Settings
            </label>
            <div className="col-md-7 mt-1 text-right">
              <button
                type="button"
                className="btn btn-secondary btn-sm se-btn-secondary"
                onClick={()=>{
                  if(isBoostPro){
                   setAlert((prev) => {
                      return {
                        ...prev,
                        message: <AlertMessages.boostProAlert />,
                        alertPopUpStatus: true,
                        title:"Information"
                      };
                    });
                  }else if(isacCoulpedPcu && projectTypeValue === "MGaaS ETO"){
                    setAlert((prev) => {
                      return {
                        ...prev,
                        message:`Schneider Electric hold all business relationships with Pylontech. As of October 29, 2025, Schneider Electric will only support the existing Pylontech Installed Base deployed with Schneider Electric's Microgrid Solution. For any questions, please contact your Schneider Electric customer tech support team – microgridsupport@se.com`,
                        alertPopUpStatus: true,
                        title:"Information"
                      };
                    });
                  }else{
                     updateBatteryConfig(selectedValues?.selectedAsset)
                  }
                 
                }}
              >
                <se-icon size="nano">action_save</se-icon>
                <span>&nbsp;</span>Save Settings
              </button>
            </div>
          </div>
        </div>
        <div
          className="col-md-12 pt-2 pb-2 se-grey-background"
          style={{
            height: "520px",
            overflowY:
              CBAssetList[selectedValues?.selectedAsset]?.uiData
                ?.bessController ||
              CBAssetList[selectedValues?.selectedAsset]?.assetType === "BESS"
                ? "scroll"
                : "hidden",
          }}
        >
          {/* Unified BESS paralleling checkbox (deduplicated) */}
          {false && (
            <div className="custom-control custom-checkbox d-flex">
              <input
                type="checkbox"
                className="custom-control-input asCompatible"
                name="bessParalleling"
                id="bessParallelingCheckbox"
                onChange={(e) => handleBessController(selectedIndex, e)}
                checked={bessControllerEnabled}
              />
              <label
                style={{ display: "inline" }}
                className="custom-control-label line-height-25"
                htmlFor="bessParallelingCheckbox"
              >
                {"Enable BESS paralleling (via Master BESS controller)"}
              </label>
              <Tooltip
                position="left"
                iconColor="secondary"
                information="External BESS combiner board needed to combine multiple BESS circuits into one, connected to ECC"
              />
            </div>
          )}
            
          {[
            embLabels.GRID_CONNECTED,
            embLabels.GRID_CONNECTED_GSX,
            embLabels.ISLANDABLE,
          ].includes(siteType) && (
            <div className="form-group mb-1">
              {
                // siteType === embLabels.GRID_CONNECTED &&
                (clientType === embLabels.GENERIC_PROJECT ||
                  clientType === embLabels.GREENSTRUXURE_PROJECT) &&
                  ["MGaaS IEC", "MGaaS ANSI", "MGaaS ETO"].includes(
                    projectTypeValue
                  ) && (
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input asCompatible"
                        name="pmRequired"
                        id="pmRequiredValidation"
                        onChange={() =>
                          handlePmAssetRequired(selectedValues.selectedAsset)
                        }
                        value={
                          CBAssetList[selectedValues.selectedAsset].uiData
                            .pmRequired
                        }
                        checked={
                          CBAssetList[selectedValues.selectedAsset].uiData
                            .pmRequired
                        }
                      />
                      <label
                        className="custom-control-label line-height-25"
                        htmlFor="pmRequiredValidation"
                      >
                        {"Enable resource energy monitoring"}
                      </label>
                      <Tooltip
                        position="left"
                        iconColor="secondary"
                        information=" Once selected, a power meter will be added to this branch to allow accurate metering, or specific sub metering function"
                      />
                    </div>
                  )
              }
              {/* Removed duplicate BESS paralleling checkbox block */}

              {(projectTypeValue === "MGaaS IEC" ||
                projectTypeValue === "MGaaS ETO") && (
                <div className="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    className="custom-control-input asCompatible"
                    name="cBRequired"
                    id="cBRequiredValidation"
                    onChange={(e) =>
                      spanishCodeRealTime
                        ? undefined
                        : handleCbAssetRequired(selectedValues.selectedAsset, e)
                    }
                    value={
                      CBAssetList[selectedValues.selectedAsset].uiData
                        .cbRequired
                    }
                    checked={
                      CBAssetList[selectedValues.selectedAsset].uiData
                        .cbRequired
                    }
                  />
                  <label
                    className="custom-control-label line-height-25"
                    htmlFor="cBRequiredValidation"
                  >
                    {"Enable breaker control"}
                  </label>
                  <Tooltip
                    position="left"
                    iconColor="secondary"
                    information=" Select this option to allow manual branch operation via EMO-M HMI."
                  />
                </div>
              )}
            </div>
          )}

          {["NO_FUEL", "FUEL_ERASER", "FUEL_SAVER"].includes(gridSettingMode) && (
            <div className="custom-control custom-checkbox">
              <input
                type="checkbox"
                className="custom-control-input asCompatible"
                name="energyReserve"
                id="energyReserve"
                onChange={handleEnergyRquired}
                value={
                  CBAssetList[selectedValues.selectedAsset].uiData
                    .energyReserveRequired
                }
                checked={
                  CBAssetList[selectedValues.selectedAsset].uiData
                    .energyReserveRequired
                }
              />
              <label
                className="custom-control-label line-height-25"
                htmlFor="energyReserve"
              >
                {"Energy Reserve"}
              </label>
              <Tooltip
                position="left"
                iconColor="secondary"
                information=" Reserve energy to support the loads during islanding. Example: If 40% of BESS capacity is reserved for islanding, only the remaining capacity will be utilized to support economic optimization when grid is available."
              />
            </div>
          )}

          <div className="form-group mb-1">
            <label htmlFor="exampleFormControlInput1">
              Name <span className="se-mandatory">*</span>
            </label>
            <input
              type="text"
              autoComplete="none"
              className={"form-control form-control-sm "}
              id="exampleFormControlInput1"
              name="name"
              maxLength="50"
              value={configData?.configData?.name}
              onChange={batteryChangeHandler}
              placeholder="Name"
            />
            <div
              className="invalid-feedback-custom"
              style={!configData?.configData?.name ? {} : { display: "none" }}
            >
              {embLabels.nameRequired}
            </div>
            <div
              className="invalid-feedback-custom"
              style={
                configData?.configData?.name !== "" &&
                !/^[a-zA-Z0-9-_& ]+$/.test(configData?.configData?.name)
                  ? {}
                  : { display: "none" }
              }
            >
              {embLabels.notallowedAlphanumericValues}
            </div>
          </div>
          {[embLabels.GRID_CONNECTED_GSX, embLabels.ISLANDABLE_GSX].includes(
            siteType
          ) &&
            (projectTypeValue === "DaaS ANSI" ||
              projectTypeValue === "DaaS ETO") &&
            (architectureType === embLabels.PV_BESS_NR ||
              architectureType === embLabels.PV_GENSET_ATS) && (
              <div className="form-group mb-1">
                <label htmlFor="batteryDeviceName">
                  Device Name <span className="se-mandatory">*</span>
                </label>
                <input
                  type="text"
                  autoComplete="none"
                  className={"form-control form-control-sm "}
                  id="batteryDeviceName"
                  name="deviceName"
                  maxLength="50"
                  value={configData?.configData?.deviceName}
                  onChange={batteryChangeHandler}
                  placeholder="Device name"
                />
                <div
                  className="invalid-feedback-custom"
                  style={
                    !configData?.configData?.deviceName
                      ? {}
                      : { display: "none" }
                  }
                >
                  {embLabels.deviceNameRequired}
                </div>
                {(projectTypeValue !== "DaaS ANSI" ||
                  projectTypeValue !== "DaaS ETO") && (
                  <div
                    className="invalid-feedback-custom"
                    style={
                      configData?.configData?.deviceName !== "" &&
                      !/^[a-z0-9-_]+$/.test(configData?.configData?.deviceName)
                        ? {}
                        : { display: "none" }
                    }
                  >
                    {embLabels.notallowedAlphanumericValues}
                  </div>
                )}
                {(projectTypeValue === "DaaS ANSI" ||
                  projectTypeValue === "DaaS ETO") && (
                  <div
                    className="invalid-feedback-custom"
                    style={
                      configData?.configData?.deviceName !== "" &&
                      !/^[a-z0-9-_]+$/.test(configData?.configData?.deviceName)
                        ? {}
                        : { display: "none" }
                    }
                  >
                    {"Invalid Name"}
                  </div>
                )}
              </div>
            )}

          {[embLabels.GRID_CONNECTED_GSX, embLabels.ISLANDABLE_GSX].includes(
            siteType
          ) &&
            (architectureType === embLabels.PV_BESS_NR ||
              architectureType === embLabels.PV_GENSET_ATS) && (
              <div className="form-group mb-1">
                <label htmlFor="exampleFormControlInput1">External ID</label>
                <input
                  type="text"
                  autoComplete="none"
                  className="form-control form-control-sm"
                  id="exampleFormControlInput1"
                  placeholder="External ID"
                  onChange={batteryChangeHandler}
                  name="externalId"
                  maxLength="64"
                  value={gsxExternalId.batteryExternalId}
                />
              </div>
            )}

          <div className="form-group mb-1">
            <label htmlFor="exampleFormControlInput1">Description</label>
            <input
              type="text"
              autoComplete="none"
              className="form-control form-control-sm"
              id="exampleFormControlInput1"
              placeholder="Description"
              name="description"
              onChange={batteryChangeHandler}
              maxLength="100"
              value={configData?.configData?.description}
            />
          </div>
          {
            isBoostPro && <>
            <div className="form-group mb-1">
                  <label htmlFor="numberOfBess">
                    Number of BESS
                  </label>

                  <select
                    className="form-control form-control-sm"
                    name="quantityOfBessPro"
                    id="quantityOfBessPro"
                    value={configData?.configData?.quantityOfBess}
                    onChange={batteryChangeHandler}
                  >
                    {configData?.configData?.quantityOfBessList?.map(
                      (quantity) => (
                        <option value={quantity} key={quantity}>
                          {quantity}
                        </option>
                      )
                    )}
                  </select>
                </div>
            </>
          }

          {CBAssetList[selectedValues?.selectedAsset]?.uiData?.bessController &&
            isBessController && (
              <>
                <div className="form-group mb-1">
                  <label htmlFor="quantityOfBess">
                    Quantity of Schneider Electric BESS
                  </label>

                  <select
                    className="form-control form-control-sm"
                    name="quantityOfBess"
                    id="quantityOfBess"
                    value={configData?.configData?.quantityOfBess}
                    onChange={batteryChangeHandler}
                  >
                    {configData?.configData?.quantityOfBessList?.map(
                      (quantity) => (
                        <option value={quantity} key={quantity}>
                          {quantity}
                        </option>
                      )
                    )}
                  </select>
                </div>
                <div className="form-group mb-1">
                  <label htmlFor="perUnitMaxPowerKw">
                    Per Unit Max Power (kW)
                  </label>
                  <Tooltip
                    position="left"
                    iconColor="secondary"
                    information="BESS units of same kW and kWh rating, can only be parallelled"
                  />
                  <input
                    type="text"
                    autoComplete="none"
                    className="form-control form-control-sm"
                    id="perUnitMaxPowerKw"
                    placeholder="Per Unit Max Power (kW)"
                    name="perUnitMaxPower"
                    onChange={batteryChangeHandler}
                    maxLength="100"
                    value={configData?.configData?.perUnitMaxPower}
                  />
                </div>
                <div className="form-group mb-1">
                  <label htmlFor="perUnitMaxEnergyKw">
                    Per Unit Max Energy (kWh)
                  </label>
                  <Tooltip
                    position="left"
                    iconColor="secondary"
                    information="BESS units of same kW and kWh rating, can only be parallelled"
                  />
                  <input
                    type="text"
                    autoComplete="none"
                    className="form-control form-control-sm"
                    id="perUnitMaxEnergyKw"
                    placeholder="Per Unit Max Energy (kWh)"
                    name="perUnitMaxEnergy"
                    onChange={batteryChangeHandler}
                    maxLength="100"
                    value={configData?.configData?.perUnitMaxEnergy}
                  />
                </div>
                {/* <div className="form-group mb-1">
                <label htmlFor="totalBessMaxPower">
                  Total BESS Max Power (kW)
                </label>
                <input
                  type="text"
                  autoComplete="none"
                  className="form-control form-control-sm"
                  id="totalBessMaxPower"
                  placeholder="Total BESS Max Power (kW)"
                  name="totalBessMaxPower"
                  onChange={undefined}
                  maxLength="100"
                  value={configData?.configData?.totalBessMaxPower}
                  disabled
                />
              </div> */}
                {/* <div className="form-group mb-1">
                <label htmlFor="totalBessMaxEnergy">
                  Total BESS Max Energy (kWh)
                </label>
                <input
                  type="text"
                  autoComplete="none"
                  className="form-control form-control-sm"
                  id="totalBessMaxEnergy"
                  placeholder="Total BESS Max Energy (kWh)"
                  name="totalBessMaxEnergy"
                  onChange={undefined}
                  maxLength="100"
                  value={configData?.configData?.totalBessMaxEnergy}
                  disabled
                />
              </div> */}
              </>
            )}
          <div className="form-group mb-1">
            <label htmlFor="exampleFormControlInput1">
              {CBAssetList[selectedValues?.selectedAsset]?.uiData?.bessController && isBessController
                ? " Total BESS Max Power (kW)"
                : "Max Power(kW)"}
              <span className="se-mandatory">*</span>
            </label>
            {Array.isArray(values) ? (
              <select
                className="form-control form-control-sm"
                name="max_power"
                id="exampleFormControlInput1"
                value={configData?.configData?.max_power}
                onChange={batteryChangeHandler}
              >
                {values?.length &&
                  values.map((val) => (
                    <option value={val.toFixed(1)} key={val}>
                      {val.toFixed(1)}
                    </option>
                  ))}
              </select>
            ) : (
              <div>
                <input
                  type="text"
                  autoComplete="none"
                  className={"form-control form-control-sm "}
                  id="exampleFormControlInput1"
                  name="max_power"
                  maxLength="4"
                  value={configData?.configData?.max_power}
                  placeholder="Max Power(kW)"
                  onChange={
                    CBAssetList[selectedValues?.selectedAsset]?.uiData
                      ?.bessController && isBessController
                      ? undefined
                      : batteryChangeHandler
                  }
                  disabled={
                   ( CBAssetList[selectedValues?.selectedAsset]?.uiData
                      ?.bessController && isBessController) || isBoostPro
                  }
                />
                <div
                  className="invalid-feedback-custom"
                  style={
                    !(parseInt(configData?.configData?.max_power) >= 0)
                      ? {}
                      : { display: "none" }
                  }
                >
                  Max Power(kW) is required.
                </div>
                {configData?.configData?.max_power !== "" &&
                (parseInt(configData?.configData?.max_power) <
                  defaultsMinMax?.maxPowerBessMin ||
                  parseInt(configData?.configData?.max_power) >
                    maxPowerBessMax) ? (
                  <div className="invalid-feedback-custom">
                    Max Power should be in range(
                    {defaultsMinMax?.maxPowerBessMin}-{maxPowerBessMax} kW).
                  </div>
                ) : (
                  ""
                )}
              </div>
            )}
          </div>
          <div className="form-group mb-1">
            <label htmlFor="exampleFormControlInput1">
              {CBAssetList[selectedValues?.selectedAsset]?.uiData
                ?.bessController && isBessController
                ? " Total BESS Max Energy (kWh)"
                : " Capacity(kWh)"}
              <span className="se-mandatory">*</span>
            </label>
            <input
              type="text"
              autoComplete="none"
              className={"form-control form-control-sm "}
              id="exampleFormControlInput1"
              placeholder="Capacity(kWh)"
              maxLength={4}
              name="capacity"
              value={configData?.configData?.capacity}
              onChange={
                CBAssetList[selectedValues?.selectedAsset]?.uiData
                  ?.bessController && isBessController
                  ? undefined
                  : batteryChangeHandler
              }
              disabled={
               ( CBAssetList[selectedValues?.selectedAsset]?.uiData
                  ?.bessController && isBessController) || isBoostPro
              }
            />
            <div
              className="invalid-feedback-custom"
              style={
                !(parseInt(configData?.configData?.capacity) >= 0)
                  ? {}
                  : { display: "none" }
              }
            >
              Capacity is required (kWh) .
            </div>
            {configData?.configData?.capacity !== "" &&
            (parseInt(configData?.configData?.capacity) <
              defaultsMinMax?.capacityBessMin ||
              parseInt(configData?.configData?.capacity) > capacityBessMax) ? (
              <div className="invalid-feedback-custom">
                Capacity should be in range(
                {defaultsMinMax?.capacityBessMin}-{capacityBessMax} kWh).
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="form-group mb-1">
            <label htmlFor="exampleFormControlInput1">
              SOC Max Manufacturer (% of battery capacity in kWh){" "}
              <span className="se-mandatory">*</span>
            </label>
            <input
              type="text"
              autoComplete="none"
              className={"form-control form-control-sm "}
              id="exampleFormControlInput1"
              placeholder="SOC Max (% of battery capacity in kWh)"
              name="soc_max"
              maxLength={4}
              value={configData?.configData?.soc_max}
              onChange={batteryChangeHandler}
            />
            <div
              className="invalid-feedback-custom"
              style={
                !(parseInt(configData?.configData?.soc_max) >= 0)
                  ? {}
                  : { display: "none" }
              }
            >
              SOC Max (% of battery capacity in kWh) is required.
            </div>
            {isBoostPro ? (
              configData?.configData?.soc_min !== "" &&
              parseInt(configData?.configData?.soc_min) > configData?.configData?.soc_max ? (
                <div className="invalid-feedback-custom">
                  SOC Min should be less than {configData?.configData?.soc_max}%.
                </div>
              ) : (
                ""
              )
            ) : (
              configData?.configData?.soc_min !== "" &&
              (parseInt(configData?.configData?.soc_min) < defaultsMinMax?.socMinMin ||
                parseInt(configData?.configData?.soc_min) > defaultsMinMax?.socMinMax) ? (
                <div className="invalid-feedback-custom">
                  SOC Min should be in range(
                  {defaultsMinMax?.socMinMin}-{defaultsMinMax?.socMinMax} % of Max
                  power).
                </div>
              ) : (
                ""
              )
            )}
          </div>

          <div className="form-group mb-1">
            <label htmlFor="exampleFormControlInput1">
              SOC Min Manufacturer(% of battery capacity in kWh){" "}
              <span className="se-mandatory">*</span>
            </label>
            <input
              type="text"
              autoComplete="none"
              className={"form-control form-control-sm "}
              id="exampleFormControlInput1"
              placeholder="SOC Min (% of battery capacity in kWh)"
              maxLength={4}
              name="soc_min"
              value={configData?.configData?.soc_min}
              onChange={batteryChangeHandler}
            />
            <div
              className="invalid-feedback-custom"
              style={
                !(parseInt(configData?.configData?.soc_min) >= 0)
                  ? {}
                  : { display: "none" }
              }
            >
              SOC Min Manufacturer(% of battery capacity in kWh) is required.
            </div>
            {configData?.configData?.soc_min !== "" &&
            (parseInt(configData?.configData?.soc_min) <
              defaultsMinMax?.socMinMin ||
              parseInt(configData?.configData?.soc_min) >
                defaultsMinMax?.socMinMax) ? (
              <div className="invalid-feedback-custom">
                SOC Min should be in range(
                {defaultsMinMax?.socMinMin}-{defaultsMinMax?.socMinMax} % of Max
                power).
              </div>
            ) : (
              ""
            )}
          </div>


      {   
      CBAssetList[selectedValues.selectedAsset].uiData
                    .energyReserveRequired && 
            <div className="form-group mb-1">
            <label htmlFor="exampleFormControlInput1">
              SOC Min Optimization(% of battery capacity in kWh){" "}
              <span className="se-mandatory">*</span>
            </label>
            <input
              type="text"
              autoComplete="none"
              className={"form-control form-control-sm "}
              id="exampleFormControlInput1"
              placeholder="SOC Min Optimization(% of battery capacity in kWh)"
              maxLength={4}
              name="SoC_min_optimization"
              value={configData?.configData?.SoC_min_optimization}
              onChange={batteryChangeHandler}
            />
            <div
              className="invalid-feedback-custom"
              style={
                !(parseInt(configData?.configData?.SoC_min_optimization) >= 0)
                  ? {}
                  : { display: "none" }
              }
            >
              SOC Min (% of battery capacity in kWh) is required.
            </div>
            {configData?.configData?.SoC_min_optimization !== "" &&
            (parseInt(configData?.configData?.SoC_min_optimization) <=
              configData?.configData?.soc_min ||
              parseInt(configData?.configData?.SoC_min_optimization) >
                defaultsMinMax?.socMinMax ||
                parseInt(configData?.configData?.SoC_min_optimization) >
               defaultsMinMax?.socEmergencyDefault
              ) ? (
              <div className="invalid-feedback-custom">
                  SOC Min optimization should be greater than SOC Min Manufacturer(
                    {configData?.configData?.soc_min}) and less than SOC Emergency (
                    {defaultsMinMax?.socEmergencyDefault}).
              </div>
            ) : (
              ""
            )}
          </div>}
          <div
            className="form-group mb-1"
            style={{ display: "none" }}
          >
            <label htmlFor="exampleFormControlInput1">
              SOC Non Essential Load Reconnection (% of battery capacity in kWh){" "}
              <span className="se-mandatory">*</span>
            </label>
            <input
              type="text"
              autoComplete="none"
              className={"form-control form-control-sm "}
              id="exampleFormControlInput1"
              placeholder="SOC Non Essential Load Reconnection (% of battery capacity in kWh)"
              maxLength={4}
              name="soc_nominal_power"
              value={configData?.configData?.soc_nominal_power}
              onChange={batteryChangeHandler}
            />
            <div
              className="invalid-feedback-custom"
              style={
                !(parseInt(configData?.configData?.soc_nominal_power) >= 0)
                  ? {}
                  : { display: "none" }
              }
            >
              SOC Non Essential Load Reconnection(% of battery capacity in kWh) is required.
            </div>
            {configData?.configData?.soc_nominal_power !== "" && !isValid ? (
              <div className="invalid-feedback-custom">
                {siteType === embLabels.ISLANDABLE ||
                siteType === embLabels.ISLANDABLE_GSX ? (
                  <>
                    SOC Non Essential Load Reconnection should be greater than  SOC Non Essential LoadShedding(
                    {defaultsMinMax?.socEssentialDefault}) and SOC Essential LoadShedding (
                    {defaultsMinMax?.socEmergencyDefault}), and less than{" "}
                    {configData?.configData?.soc_max} of SOC Max Manufacturer.
                  </>
                ) : (
                  <>
                    SOC Non Essential Load Reconnection should be in range ({soc_min}-{soc_max} % of SOC Max Manufacturer).
                  </>
                )}
              </div>
            ) : (
              ""
            )}
          </div>
 <div
            className="form-group mb-1" >
            <label htmlFor="exampleFormControlInput1">
              SOC Fallback (% of battery capacity in kWh){" "}
              <span className="se-mandatory">*</span>
            </label>
            <input
              type="text"
              autoComplete="none"
              className={"form-control form-control-sm "}
              id="exampleFormControlInput1"
              placeholder="SOC Fallback (% of battery capacity in kWh)"
              maxLength={4}
              name="SoC_fallback"
              value={configData?.configData?.SoC_fallback}
              onChange={batteryChangeHandler}
            />
            <div
              className="invalid-feedback-custom"
              style={
                !(parseInt(configData?.configData?.SoC_fallback) >= 0)
                  ? {}
                  : { display: "none" }
              }
            >
              SoC fallback(% of battery capacity in kWh) is required.
            </div>
            {configData?.configData?.SoC_fallback !== "" && (Number(configData?.configData?.SoC_fallback) < Number(configData?.configData?.soc_min) || Number(configData?.configData?.SoC_fallback) > Number(configData?.configData?.soc_max))  && (
              <div className="invalid-feedback-custom">
                  <>
                    SOC fallback should be greater than SOC Min Manufacturer(
                    {configData?.configData?.soc_min}) and less than{" "}
                    {configData?.configData?.soc_max} of SOC Max Manufacturer.
                  </>
              
              </div>
            )}
          </div>
        </div>
      </div>
       <Alert alert={alert} onClose={closeAlertMessage} />
    </div>
    
  );
};

export default BatteryAsset;
